import jQuery from 'jquery';
import focusWithin from 'focus-within';
import { infinite } from './infinite';
import { animateStats } from './animate-stats';
import { tabs } from './tabs';
import { filters } from './filters';
import { header } from './header';
import { homeHero } from './homeHero';
import { homeSlider } from './homeSlider';
import { carousel } from './carousel';
import { testimonials } from './testimonials';
import { accordion } from './accordion';
import { floating } from './floating';
import { team } from './team';
import { animate } from './animate';

jQuery(document).ready(function($) {
	// Remove no-js class and replace with js.
	$('html').addClass('js').removeClass('no-js');

	// :focus-within polyfill
	focusWithin(document);

	header.init();
	homeHero.init();
	homeSlider.init();
	infinite.init();
	animateStats.init();
	tabs.init();
	filters.init();
	carousel.init();
	testimonials.init();
	accordion.init();
	floating.init();
	team.init();
	animate.init();

	$('.modal-close').on('click', () => {
		$('body').removeClass('show-overlay');
		$('.team-overlay').removeClass('active');
	});

	$('#content-wrapper').addClass('show');

	$(window).scroll();
	$(window).resize();
});